.identity {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-8);
}

.pillars {
  display: grid;
  gap: var(--pgm-sys-spacing-6);
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.card {
  border: 1px solid var(--pgm-sys-color-outline-variant);
  border-radius: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-4);
  padding: var(--pgm-sys-spacing-6);
}

.cardWide {
  grid-column: 1 / -1;
}

.pillarHead {
  align-items: center;
  display: flex;
  gap: var(--pgm-sys-spacing-3);
}

.pillarIcon {
  align-items: center;
  background-color: var(--pgm-sys-color-primary);
  border-radius: 8px;
  color: var(--pgm-sys-color-on-primary);
  display: flex;
  flex-shrink: 0;
  height: 48px;
  justify-content: center;
  width: 48px;

  span {
    font-size: 32px;
    line-height: 32px;
  }
}

.pillarTitle,
.valueTitle,
.text {
  margin: 0;
}

.pillarTitle,
.text {
  color: var(--pgm-sys-color-on-surface);
}

.valuesBlock {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
}

.valuesHeader {
  align-items: center;
  border-bottom: 1px solid var(--pgm-sys-color-outline-variant);
  display: flex;
  gap: var(--pgm-sys-spacing-2);
  padding: var(--pgm-sys-spacing-2) 0;
}

.valuesIcon {
  color: var(--pgm-sys-color-secondary);
  font-size: 32px;
  line-height: 32px;
}

.valuesLabel {
  color: var(--pgm-sys-color-secondary);
  margin: 0;
  text-transform: uppercase;
}

.values {
  display: grid;
  gap: var(--pgm-sys-spacing-6);
  grid-template-columns: repeat(4, minmax(0, 1fr));
  padding-bottom: var(--pgm-sys-spacing-4);
}

.valueCard {
  border: 1px solid var(--pgm-sys-color-outline-variant);
  border-radius: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
  padding: var(--pgm-sys-spacing-6);
}

.valueHead {
  align-items: center;
  display: flex;
  gap: var(--pgm-sys-spacing-2);
}

.valueIcon,
.valueTitle {
  color: var(--pgm-sys-color-secondary);
}

.valueIcon {
  flex-shrink: 0;
  font-size: 24px;
  line-height: 24px;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--pgm-sys-spacing-4);
}

.action {
  align-items: center;
  border: 1px solid var(--pgm-sys-color-outline-variant);
  border-radius: 28px;
  color: var(--pgm-sys-color-on-surface-variant);
  display: inline-flex;
  gap: var(--pgm-sys-spacing-2);
  padding: var(--pgm-sys-spacing-4) var(--pgm-sys-spacing-6);
  text-decoration: none;
}

.actionIcon {
  font-size: 24px;
  font-variation-settings:
    "FILL" 1,
    "wght" 600,
    "GRAD" 0,
    "opsz" 24;
  line-height: 24px;
}

.action:hover,
.action:focus {
  background-color: var(--pgm-sys-color-surface-container-low);
  color: var(--pgm-sys-color-on-surface-variant);
  text-decoration: none;
}

@media (max-width: 1199.98px) {
  .values {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 767.98px) {
  .pillars,
  .values {
    grid-template-columns: minmax(0, 1fr);
  }

  .cardWide {
    grid-column: auto;
  }
}
